import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import Navbar from "@/components/app/Navbar";
import Home from "@/pages/Home";
import HiraganaPage from "@/pages/HiraganaPage";
import KatakanaPage from "@/pages/KatakanaPage";
import KanjiPage from "@/pages/KanjiPage";
import FlashcardsPage from "@/pages/FlashcardsPage";
import PDFPage from "@/pages/PDFPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/learn/hiragana" element={<HiraganaPage />} />
              <Route path="/learn/katakana" element={<KatakanaPage />} />
              <Route path="/learn/kanji" element={<KanjiPage />} />
              <Route path="/practice" element={<FlashcardsPage />} />
              <Route path="/pdf" element={<PDFPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
            </Routes>
            <Toaster richColors position="top-center" toastOptions={{ style: { borderRadius: "1rem", fontFamily: "Nunito, sans-serif", fontWeight: 700 } }} />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
